<form [formGroup]="form" autocomplete="off" class="overflow-x-hidden">
  <!--  <div class="page-title pb-3 border-b flex items-center">-->
  <!--    <h2 class="title m-0">{{'Table filter' | translate }}</h2>-->
  <!--  </div>-->
  <div class="flex sm:flex-row sm:gap-4 gap-2 w-100 row-wrap">
    <!--/////////////////donations filter///////////////////////////-->
    <ng-container *ngIf="listType === 'donations'">
      <mat-form-field class="flex-auto max-w-[300px] w-25 w-sm-100 mrgn-b-md">
        <mat-label>{{'Created at from' | translate}}</mat-label>
        <input readonly matInput formControlName="from_date" [matDatepicker]="pickerDonFrom">
        <mat-datepicker-toggle matSuffix [for]="pickerDonFrom"></mat-datepicker-toggle>
        <mat-datepicker #pickerDonFrom></mat-datepicker>
        <mat-error
          *ngIf="form.get('from_date').hasError('wrong') && form.controls['from_date'].touched">
          {{'You need to enter the date' | translate}}
        </mat-error>
      </mat-form-field>
      <mat-form-field class="flex-auto max-w-[300px] w-25 w-sm-100 mrgn-b-md">
        <mat-label>{{'Created at to' | translate}}</mat-label>
        <input readonly matInput formControlName="to_date" [matDatepicker]="pickerDonTo">
        <mat-datepicker-toggle matSuffix [for]="pickerDonTo"></mat-datepicker-toggle>
        <mat-datepicker #pickerDonTo></mat-datepicker>
        <mat-error
          *ngIf="form.get('to_date').hasError('wrong') && form.controls['to_date'].touched">
          {{'You need to enter the date' | translate}}
        </mat-error>
      </mat-form-field>
      <div class="flex-auto max-w-[300px] w-25 w-sm-100 mrgn-b-md">
        <ng-multiselect-dropdown
          [placeholder]="'Select a donation path' | translate"
          [settings]="dropdownSettings"
          [data]="donationPaths"
          formControlName="donation_path"
          [disabled]="disabled"
        >
        </ng-multiselect-dropdown>
      </div>
    </ng-container>
    <!--/////////////////donations filter///////////////////////////-->

    <!--/////////////////notifications filter///////////////////////////-->
    <ng-container *ngIf="listType === 'notifications'">
      <mat-form-field class="flex-auto max-w-[300px] w-25 w-sm-100 mrgn-b-md">
        <mat-label>{{'Select status' | translate}}</mat-label>
        <input type="text" matInput formControlName="notifications_status" [matAutocomplete]="auto99">
        <mat-autocomplete #auto99="matAutocomplete" [displayWith]="displayFn"
                          (opened)="handlerAutocomplete('notifications_status')">
          <mat-option *ngFor="let option of statusFilteredOptions | async" [value]="option">
            <img *ngIf="option.flag || option.image" [src]="option.flag" class="align-middle mr-4 shadow-lg"
                 height="25">
            <span class="body-1">{{ option.name | translate }}</span>
          </mat-option>
        </mat-autocomplete>
        <button class="text-secondary" mat-icon-button matSuffix type="button">
          <mat-icon svgIcon="mat:arrow_drop_down"></mat-icon>
        </button>
        <mat-error
          *ngIf="form.get('notifications_status').hasError('wrong') && form.controls['notifications_status'].touched">
          {{'You need to choose a valid status' | translate}}
        </mat-error>
      </mat-form-field>
    </ng-container>
    <!--/////////////////notifications filter///////////////////////////-->

    <!--/////////////////students or teachers filter///////////////////////////-->
    <ng-container *ngIf="listType === 'xx'">
      <mat-form-field class="flex-auto max-w-[300px] w-25 w-sm-100 mrgn-b-md">
        <mat-label>{{'Select a country' | translate}}</mat-label>
        <input type="text" matInput formControlName="country" [matAutocomplete]="auto0">
        <mat-autocomplete #auto0="matAutocomplete" [displayWith]="displayFn"
                          (opened)="handlerAutocomplete('country')">
          <mat-option *ngFor="let option of countriesFilteredOptions | async" [value]="option">
            <img *ngIf="option.flag || option.image"
                 [src]="option.flag.includes('https') ? option.flag : (apiUrl + option.flag)"
                 class="align-middle mr-4 shadow-lg"
                 height="25">
            <span class="body-1">{{ option.name | translate }}</span>
          </mat-option>
        </mat-autocomplete>
        <button class="text-secondary" mat-icon-button matSuffix type="button">
          <mat-icon svgIcon="mat:arrow_drop_down"></mat-icon>
        </button>
        <mat-error
          *ngIf="form.get('country').hasError('wrong') && form.controls['country'].touched">
          {{' You need to choose a valid country' | translate}}
        </mat-error>
      </mat-form-field>
      <mat-form-field class="flex-auto max-w-[300px] w-25 w-sm-100 mrgn-b-md">
        <mat-label>{{'Select a gender' | translate}}</mat-label>
        <input type="text" matInput formControlName="gender" [matAutocomplete]="auto8">
        <mat-autocomplete #auto8="matAutocomplete" [displayWith]="displayFn"
                          (opened)="handlerAutocomplete('gender')">
          <mat-option *ngFor="let option of gendersFilteredOptions | async" [value]="option">
            <img *ngIf="option.flag || option.image" [src]="option.flag" class="align-middle mr-4 shadow-lg"
                 height="25">
            <span class="body-1">{{ option.name | translate }}</span>
          </mat-option>
        </mat-autocomplete>
        <button class="text-secondary" mat-icon-button matSuffix type="button">
          <mat-icon svgIcon="mat:arrow_drop_down"></mat-icon>
        </button>
        <mat-error
          *ngIf="form.get('gender').hasError('wrong') && form.controls['gender'].touched">
          {{'You need to choose a valid gender' | translate}}
        </mat-error>
      </mat-form-field>
      <mat-form-field class="flex-auto max-w-[300px] w-25 w-sm-100 mrgn-b-md">
        <mat-label>{{'Status' | translate}}</mat-label>
        <input type="text" matInput formControlName="active_status" [matAutocomplete]="active_status">
        <mat-autocomplete #active_status="matAutocomplete" [displayWith]="displayFn"
                          (opened)="handlerAutocomplete('active_status')">
          <mat-option *ngFor="let option of active_statusFilteredOptions | async" [value]="option">
            <span class="body-1">{{ option.name | translate }}</span>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </ng-container>
    <!--/////////////////students or teachers filter///////////////////////////-->


    <!--/////////////////teachers or students or notifications filter///////////////////////////-->
    <ng-container *ngIf="listType === 'notifications' || listType === 'support_tickets'">
      <mat-form-field class="flex-auto max-w-[300px] w-25 w-sm-100 mrgn-b-md">
        <mat-label>{{'Created at from' | translate}}</mat-label>
        <input readonly matInput formControlName="from_date" [matDatepicker]="picker">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error
          *ngIf="form.get('from_date').hasError('wrong') && form.controls['from_date'].touched">
          {{'You need to enter the date' | translate}}
        </mat-error>
      </mat-form-field>
      <mat-form-field class="flex-auto max-w-[300px] w-25 w-sm-100 mrgn-b-md">
        <mat-label>{{'Created at to' | translate}}</mat-label>
        <input readonly matInput formControlName="to_date" [matDatepicker]="picker1">
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
        <mat-error
          *ngIf="form.get('to_date').hasError('wrong') && form.controls['to_date'].touched">
          {{'You need to enter the date' | translate}}
        </mat-error>
      </mat-form-field>
    </ng-container>
    <!--/////////////////teachers or students or notifications filter///////////////////////////-->

    <!--/////////////////support_tickets filter///////////////////////////-->
    <ng-container *ngIf="listType === 'support_tickets'">
      <mat-form-field class="flex-auto max-w-[300px] w-25 w-sm-100 mrgn-b-md">
        <mat-label>{{'Status' | translate}}</mat-label>
        <input type="text" matInput formControlName="ticket_status" [matAutocomplete]="ticket_status">
        <mat-autocomplete #ticket_status="matAutocomplete" [displayWith]="displayFn"
                          (opened)="handlerAutocomplete('ticket_status')">
          <mat-option *ngFor="let option of supportTicketsStatusFilteredOptions | async" [value]="option">
            <img *ngIf="option.flag || option.image" [src]="option.flag" class="align-middle mr-4 shadow-lg"
                 height="25">
            <span class="body-1">{{ option.name | translate }}</span>
          </mat-option>
        </mat-autocomplete>
        <button class="text-secondary" mat-icon-button matSuffix type="button">
          <mat-icon svgIcon="mat:arrow_drop_down"></mat-icon>
        </button>
        <mat-error
          *ngIf="form.get('session_status').hasError('wrong') && form.controls['session_status'].touched">
          {{'You need to choose a valid status' | translate}}
        </mat-error>
      </mat-form-field>
      <mat-form-field class="flex-auto max-w-[300px] w-25 w-sm-100 mrgn-b-md">
        <mat-label>{{'Select a support type' | translate}}</mat-label>
        <input type="text" matInput formControlName="support_type" [matAutocomplete]="auto0001">
        <mat-autocomplete #auto0001="matAutocomplete" [displayWith]="displayFn"
                          (opened)="handlerAutocomplete('support_types')">
          <mat-option *ngFor="let option of support_typesFilteredOptions | async" [value]="option">
            <img *ngIf="option.flag || option.image" [src]="option.flag" class="align-middle mr-4 shadow-lg"
                 height="25">
            <span class="body-1">{{ option.name | translate}}</span>
          </mat-option>
        </mat-autocomplete>
        <button class="text-secondary" mat-icon-button matSuffix type="button">
          <mat-icon svgIcon="mat:arrow_drop_down"></mat-icon>
        </button>
        <mat-error
          *ngIf="form.get('support_type').hasError('wrong') && form.controls['support_type'].touched">
          {{'You need to choose a valid support type' | translate}}
        </mat-error>
      </mat-form-field>
      <mat-form-field class="flex-auto max-w-[300px] w-25 w-sm-100 mrgn-b-md">
        <mat-label>{{'Select a problem type' | translate}}</mat-label>
        <input type="text" matInput formControlName="problems_type" [matAutocomplete]="auto0002">
        <mat-autocomplete #auto0002="matAutocomplete" [displayWith]="displayFn"
                          (opened)="handlerAutocomplete('problems_types')">
          <mat-option *ngFor="let option of problems_typesFilteredOptions | async" [value]="option">
            <img *ngIf="option.flag || option.image" [src]="option.flag" class="align-middle mr-4 shadow-lg"
                 height="25">
            <span class="body-1">{{ option.name | translate }}</span>
          </mat-option>
        </mat-autocomplete>
        <button class="text-secondary" mat-icon-button matSuffix type="button">
          <mat-icon svgIcon="mat:arrow_drop_down"></mat-icon>
        </button>
        <mat-error
          *ngIf="form.get('problems_type').hasError('wrong') && form.controls['problems_type'].touched">
          {{'You need to choose a valid problem type' | translate}}
        </mat-error>
      </mat-form-field>
    </ng-container>
    <!--/////////////////support_tickets filter///////////////////////////-->

    <!--/////////////////questions filter///////////////////////////-->
    <ng-container *ngIf="listType === 'challenges' || (listType === 'users' && in_performance)">
      <mat-form-field class="flex-auto max-w-[300px]">
        <mat-label>{{ 'Door' | translate }}</mat-label>
        <mat-select formControlName="door_id">
          <mat-option *ngFor="let door of doors" [value]="door.id">
            {{ door.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>
    <!--/////////////////questions filter///////////////////////////-->
  </div>
  <div class="d-flex align-items-center justify-content-end py-2">
    <button
      type="button"
      class="mx-2"
      mat-raised-button
      (click)="resetForm()"
      color="warn"
    >
      {{ 'Reset' | translate }}
    </button>
    <button type="button" mat-raised-button (click)="apply()" color="primary">
      {{ 'Apply' | translate }}
    </button>
  </div>
</form>
